'use strict';

var $ = require('jquery');
const anime = require('animejs');
require('./urbaseranimations.js');
require('./navigation.js');
require('./contacts.js');
require('gwwp');
$(function() {

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
    
            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
    $('.accordion-button').click(function(){
        $(this).next().slideToggle();
        $(this).toggleClass('active');
        $(this).children('.plus-minus').toggleClass('opened');
    });

});